import { Content } from '../../types';

export const doiInthanonContent: Content = {
  title: 'שמורת הטבע דוי אינתהנון – הפנינה של צפון תאילנד',
  imageUrl: '/images/thailand/doi-inthanon/doi-inthanon-wide.jpeg',
  introduction:
    'שמורת הטבע דוי אינתהנון הינה אחת משמורות הטבע היפות, המגוונות והפופולריות ביותר בצפון תאילנד. היא ממוקמת כ-60 ק"מ דרומית לצ\'אנג מאי, במחוז צ\'אנג מאי ומשתרעת על פני שטח של כ-500 קמ"ר. גולת הכותרת של השמורה היא הר אינתהנון, הגבוה ביותר בתאילנד, המתנשא לגובה של 2,565 מטר מעל פני הים.',
  sections: [
    {
      title: 'אטרקציות מרכזיות בשמורה',
      type: 'sub-headers',
      description: '',
      content: [
        {
          subtitle: 'פסגת הר אינתהנון',
          text: 'הנקודה הגבוהה ביותר בתאילנד מציעה נופים עוצרי נשימה של צפון תאילנד. בפסגה יש שלט המציין את גובה ההר ונקודת תצפית נהדרת לצילום. בשל הגובה הרב, האזור נהנה ממזג אוויר קריר לאורך כל השנה ולעיתים אף ערפילי, מה שמעניק לו אווירה קסומה.',
        },
        {
          subtitle:
            'פגודות המלך והמלכה (Napha Methanidon & Napha Pholphumisiri)',
          text: 'שתי פגודות מפוארות שנבנו לכבוד יום הולדתם ה-60 של מלך ומלכת תאילנד. הן ממוקמות על שתי גבעות סמוכות, מוקפות בגנים צבעוניים ומסלולי הליכה נוחים. מהמקום נשקף נוף פנורמי מרהיב של הסביבה.',
        },
        {
          subtitle: 'מפלים מרהיבים:',
          text: '',
        },
        {
          subtitle: "מפל וואצ'יראתאן (Wachirathan Falls)",
          text: 'אחד המפלים המרשימים בשמורה, עם זרימה עוצמתית ונוף ציורי.',
        },
        {
          subtitle: 'מפל סירי פום (Siriphum Waterfall)',
          text: 'מפל גבוה במיוחד, הנשפך על צלע הר בין עצי יער עבותים.',
        },
        {
          subtitle: 'מפל מאה יא (Mae Ya Waterfall)',
          text: 'מפל רחב ויפהפה הנחשב לאחד המפלים המרשימים בתאילנד, עם זרימה רב-שלבית היוצרת מראה מדורג.',
        },
        {
          subtitle: 'מסלולי הליכה בטבע:',
          text: '',
        },
        {
          subtitle: 'מסלול אנג קא (Ang Ka Nature Trail)',
          text: 'מסלול הליכה קצר ונגיש העובר בתוך יער עננים צפוף וירוק.',
        },
        {
          subtitle: 'מסלול פאה דוק סיאהו (Pha Dok Siew Trail)',
          text: 'מסלול הליכה מומחה במפלים וטרסות אורז בצורה מרשימה.',
        },
        {
          subtitle: 'מסלול קיו מאי פאן (Kew Mae Pan Trail)',
          text: 'אחד המסלולים היפים ביותר בצפון תאילנד, באורך של כ-3 ק"מ. המסלול נפתח בעונת החורף בלבד (נובמבר-מאי) ומאפשר תצפיות פנורמיות על ההרים שמסביב.',
        },
        {
          subtitle: 'כפרי השבטים המקומיים',
          text: 'שמורת דוי אינתנון הינה ביתם של שבטי ההרים, כולל שבט קארן ושבט המונג, שמקורם בבורמה ובסין. תושבי הכפרים עוסקים בעיקר בחקלאות אורגנית ומייצרים קפה, תה וירקות. ניתן לבקר בשווקים מקומיים שבהם הם מוכרים את תוצרתם ואף ללון בבתי אירוח בכפרים ולחוות מקרוב את אורח חייהם הייחודי.',
        },
      ],
    },
    {
      title: 'אפשרויות לינה',
      type: 'sub-headers',
      description:
        "ניתן לבקר בשמורה במסגרת טיול יום מצ'אנג מאי, אך יש גם אפשרות ללון בשמורה:",
      content: [
        {
          subtitle: 'בתי הארחה של השבטים המקומיים',
          text: 'בתי הארחה פשוטים המנוהלים על ידי תושבי הכפרים באזור.',
        },
        {
          subtitle: 'בתי הארחה רשמיים',
          text: 'אכסניות המופעלות על ידי רשות הפארקים הלאומיים.',
        },
        {
          subtitle: 'מתחמי קמפינג',
          text: 'אזורים מוסדרים למי שמעוניין לחוות לינה בטבע.',
        },
      ],
    },
    {
      title: 'מתי כדאי לבקר בשמורה?',
      type: 'sub-headers',
      description:
        'ניתן לטייל בשמורה בכל חודשי השנה, אך יש לקחת בחשבון את עונות השנה:',
      content: [
        {
          subtitle: 'נובמבר - פברואר',
          text: 'התקופה הטובה ביותר לביקור, מזג האוויר קריר ונעים וראות מצויינת.',
        },
        {
          subtitle: 'מרץ - מאי',
          text: 'חם יחסית וייתכנו שריפות חקלאיות שפוגעות בראות ובאיכות האוויר.',
        },
        {
          subtitle: 'יוני - אוקטובר',
          text: 'עונת הגשמים, השמורה ירוקה ומרשימה אך המסלולים עשויים להיות חלקים ובוציים.',
        },
      ],
    },
    {
      title: 'דרכי הגעה לשמורה',
      type: 'sub-headers',
      description: '',
      content: [
        {
          subtitle: "רכב פרטי או שכור מצ'אנג מאי",
          text: 'כשעה וחצי נסיעה לכל כיוון.',
        },
        {
          subtitle: 'מוניות או הסעות פרטיות',
          text: 'עם נהג מקומי.',
        },
        {
          subtitle: 'טיולי יום מאורגנים',
          text: 'הכוללים מדריך, רכב צמוד וביקור באטרקציות המרכזיות.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      content:
        'בשורה התחתונה, שמורת הטבע דוי אינתהנון הינה יעד חובה לכל חובבי הטבע, ההרפתקאות והתרבות המקומית. השילוב של נופים עוצרי נשימה, מפלים מרהיבים, מסלולי הליכה מגוונים וכפרים אותנטיים הופכים אותה לאחת השמורות היפות והמרתקות בתאילנד.',
      type: 'text',
      isBold: true,
    },
  ],
};
